import { useQuery } from '@tanstack/react-query';
import { featureFlagControllerAtMeQueryOptions } from 'korint-sdk';

export function useFinalizeNewBusinessButtonsFlag(productId: string): boolean | undefined {
  const { data: isEnabled } = useQuery({
    ...featureFlagControllerAtMeQueryOptions({
      key: 'feat_finalize_new_business_buttons',
      productId,
    }),
    select: ({ enabled }) => enabled,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return isEnabled;
}
